import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';

const DEFAULT_OPTIONS = [5, 10, 15, 20];

export interface YearsAgoFilterProps {
  value: number | undefined;
  onChange: (value: number | undefined) => void;
  label?: string;
  required?: boolean;
  options?: number[];
  /** If true, include a "No limit" option that sends 0 (no filter). Default true. */
  allowNoLimit?: boolean;
}

/**
 * Reusable "years ago" filter for reports. Use for parameters like years_ago_inactive.
 * Value 0 means no limit (API may treat 0 as "don't filter"); positive values filter within last N years.
 */
const YearsAgoFilter: React.FC<YearsAgoFilterProps> = ({
  value,
  onChange,
  label = 'Years ago',
  required = false,
  options = DEFAULT_OPTIONS,
  allowNoLimit = true,
}) => {
  const displayValue =
    value === undefined ? '' : value === 0 ? '0' : String(value);

  return (
    <FormControl fullWidth size="small" required={required}>
      <InputLabel id="years-ago-filter-label">{label}</InputLabel>
      <Select
        labelId="years-ago-filter-label"
        id="years-ago-filter-select"
        value={displayValue}
        label={label}
        onChange={(e) => {
          const v = e.target.value;
          if (v === '') {
            onChange(undefined);
          } else {
            onChange(Number(v));
          }
        }}
      >
        {allowNoLimit && <MenuItem value="0">No limit</MenuItem>}
        {options.map((n) => (
          <MenuItem key={n} value={String(n)}>
            {n} years
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default YearsAgoFilter;
